module.exports = __webpack_public_path__ + "img/NOR.9a45d5be.svg";